export const esES_analyticTitle = {
  'analytic.name': 'Analytics',
  'analytic.notification.processing.report': 'El reporte se está procesando. Al finalizar, se enviará el archivo a su email {email}.',
  'analytic.see.chat': 'Ver chat',
  'analytic.btn.download.chat': 'Reporte de chat',
  'analytic.btn.summary.download.chat': 'Resumen',
  'analytic.tooltip.download.chat': 'Descarga los datos filtrados y/o todos los valores visibles en la tabla',
  'analytic.survey.binary': 'Binario',
  'analytic.survey.stars': 'Estrellas',
  'analytic.survey.1': '1',
  'analytic.survey.2': '2',
  'analytic.survey.3': '3',
  'analytic.survey.4': '4',
  'analytic.survey.5': '5',
  'analytic.survey.nps': 'NPS',
  'analytic.survey.positive': 'Positivo',
  'analytic.survey.positives': 'Positivo',
  'analytic.survey.neutral': 'Neutral',
  'analytic.survey.negative': 'Negativo',
  'analytic.survey.negatives': 'Negativo',
  'analytic.survey.promoters': 'Promotores',
  'analytic.survey.detractors': 'Detractores',
  'analytic.survey.csat': 'CSAT',
  'analytic.survey.none': 'Sin respuesta',
  'analytic.feedback.positive': 'Feedback positivo',
  'analytic.feedback.negative': 'Feedback negativo',
  'analytic.transferred.by.evasives': 'Transferida por evasivas',
  'analytic.transferred.by.answer': 'Transferida por respuesta',
  'analytic.other': 'Otros',
  'analytic.transferred.by.negative.feedback': 'Transferida por mal calificada',
  'analytic.transferred.by.same.answer': 'Transferida por respuestas iguales',
  'analytic.transferred.by.direct.derivation': 'Transferida por derivación directa',
  'analytic.transferred.by.answer.tool': 'Transferida por complemento',
  'analytic.retained.by.agentbot': 'Solo AgentBot',
};
